import { render } from "./oidc.vue?vue&type=template&id=07a10d12&scoped=true"
import script from "./oidc.vue?vue&type=script&lang=js"
export * from "./oidc.vue?vue&type=script&lang=js"

import "./oidc.vue?vue&type=style&index=0&id=07a10d12&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07a10d12"]])

export default __exports__